// extracted by mini-css-extract-plugin
module.exports = {"titleWrapper":"_ffd7f26","open":"_b380d8e","icon":"_b854eaa"};